module.exports = __webpack_public_path__ + "7bd8ab6b81d0417558355d959e9ef55d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/barbell.png
// module id = 1983
// module chunks = 0